import React from 'react'
import { TextField } from '@material-ui/core'
import { useCadastro, useGlobalRefresh } from '../context/AppContext'

const opcoes = [
    "Titular",
    "Dependente",
]

export default function TipoAssociado(props) {
    const [update, setUpdate] = React.useState(0)
    const { cadastro } = useCadastro()
    const { globalRefresh } = useGlobalRefresh()

    const handleChange = (e) => {
        const { value } = e.target
        cadastro.tipoAssociado = value
        setUpdate(u => u + 1)
    }

    React.useEffect(() => { }, [update, useGlobalRefresh])

    return (
        <React.Fragment>
            <TextField select SelectProps={{ native: true, }} style={{width: props.w, marginLeft: props.ml}}
                value={cadastro.tipoAssociado} onChange={handleChange} label="Tipo Associado">
                {opcoes.map((option) => (
                    <option value={option}> {option} </option>
                ))}
            </TextField>
        </React.Fragment>
    );
}